export default __webpack_public_path__ + "static/media/settings-password.64a3979a.png";